import styled from 'styled-components';
import LS from '../styles/layoutStyled'
import CS from '../styles/componentStyled'
import AlarmModal2 from './AlarmModal2';
import AlarmModal3 from './AlarmModal3';
import React, {useState, useRef, useMemo, useEffect} from 'react';
import DaumPostcode from 'react-daum-postcode';
import { useSetRecoilState, useRecoilState, useRecoilValue } from 'recoil';
import { accessTokenState, refreshTokenState, expireState } from '../atom/TokenAtom';
import { alarmModal1Text } from '../atom/ModalAtom';
import { StructureDto } from '../model/structure.dto';
import { ApiService } from '../api';
import { loadingSpinnerState } from '../atom/ModalAtom';

interface CertificateModalProps {
    mode : string;
    onClose : () => void;
    modifyItem : any;
}

const CertificateModal = ({ mode, onClose, modifyItem }: CertificateModalProps) => {
    const setAlarmText = useSetRecoilState(alarmModal1Text);
    const [loadingState, setLoadingState] = useRecoilState(loadingSpinnerState);
    const [accessToken, setAccessToken] = useRecoilState(accessTokenState)
    const [refreshToken, setRefreshToken] = useRecoilState(refreshTokenState);
    const [expire, setExpire] = useRecoilState(expireState);
    const apiService = new ApiService();

    // 시설물 번호
    const [facilityNumber, setFacilityNumber] = useState(mode === '' ? modifyItem.structure_num : '');
    const [facilityNumberDuplication, setFacilityNumberDuplication] = useState(mode === '' ? true : false);
    const handleFacilityNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setFacilityNumber(value);
        setFacilityNumberDuplication(false);
    };

    // 시설물 번호 중복 조회
    const handleDuplicateHits: any = async () => {
        if (facilityNumber.length === 0) {
            setAlarmText("입력된 값이 없습니다.");
            return;
        }
        if (!accessToken) {
            throw new Error('Access token not found');
        }
        const duplication = await apiService.duplicateHits(accessToken, facilityNumber);
        if (duplication) {
            setFacilityNumberDuplication(true);
            setAlarmText("사용 가능한 시설물 번호입니다.");
        }
    }

    // 신청자
    const [applicant, setApplicant] = useState(mode === '' ? modifyItem.applicant : '');
    const handleApplicantChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setApplicant(value);
    };

    // 휴대폰 번호
    const [phoneNumber, setPhoneNumber] = useState(mode === '' ? modifyItem.phone_number : '');
    const handlePhoneNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setPhoneNumber(value);
    };

    // 시설물 명
    const [facilityName, setFacilityName] = useState(mode === '' ? modifyItem.structure_name : '');
    const handleFacilityNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setFacilityName(value);
    };

    // 주구조
    const [mainStructure, setMainStructure] = useState(mode === '' ? modifyItem.construction : '');
    const handleMainStructureChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setMainStructure(value);
    };

    // 측정 항목
    const [measuringItem, setMeasuringItem] = useState(mode === '' ? modifyItem.measure_item : '');
    const handleMeasuringItemChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setMeasuringItem(value);
    };

    // 안전 등급
    const safetyLevelRef = useRef<HTMLSelectElement>(null);
    const [safetyLevel, setSafetyLevel] = useState<string>(mode === '' ? modifyItem.safety_grade : '');
    const handleSafetyLevelChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSafetyLevel(e.target.value);
        safetyLevelRef.current?.classList.add("selected");
    };

    // 소재지
    const [location, setLocation] = useState(mode === '' ? modifyItem.address.split("?")[0] : '');
    const [detailLocation, setdetailLocation] = useState(mode === '' ? modifyItem.address.split("?")[1] : '');
    const handleDetailLocationChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setdetailLocation(value);
    };

    //주소 검색 모달
    const [isPostModal, setIsPostModal] = useState(false);
    const onCompletePost = (data: any) => {
        setIsPostModal(false);
        setLocation(data.address);
    };

    // 유효기간
    const today = new Date().toISOString().split('T')[0];
    const oneYearLater = new Date();
    oneYearLater.setFullYear(oneYearLater.getFullYear() + 1);
    const settingDate = oneYearLater.toISOString().split('T')[0];
    const [expirationPeriod, setExpirationPeriod] = useState<string>(mode === '' ? modifyItem.exp_date : settingDate);
    const handleExpirationPeriodChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setExpirationPeriod(e.target.value);
    };

    // 안전점검기준
    const [safetyInspection, setSafetyInspection] = useState(mode === '' ? modifyItem.standard : '');
    const handleSafetyInspectionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setSafetyInspection(value);
    };

    // 휴대폰 번호 유효성 검사
    const validatePhoneNumber = (number: string): boolean => {
        const phoneNumberRegex = /^010\d{8}$/;
        return phoneNumberRegex.test(number);
    };

    // 유효성 검사
    const validation = () => {
        if (facilityNumber === '' || applicant === '' || safetyLevel === '' || location === '' || detailLocation === '' || expirationPeriod === '' || phoneNumber === '') {
            setAlarmText("빈 칸을 확인해 주세요.");
            return true;
        }
        else if (!validatePhoneNumber(phoneNumber)) {
            setAlarmText("휴대폰 번호 형식이 올바르지 않습니다.");
            return true;
        }
        else return false;
    }

    // 등록
    const api = useMemo(() => new ApiService(), []);
    const handleSubmit: any = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (validation()) return;
        if (!facilityNumberDuplication) {
            setAlarmText("시설물 번호 중복 조회를 해주세요.");
            return;
        }
        const formData: StructureDto = {
            structure_num: facilityNumber, //시설물 번호
            structure_name: facilityName, //시설물 명
            address: location.concat('?' + detailLocation), //소재지
            construction: mainStructure, //주구조
            safety_grade: safetyLevel, //안전등급
            measure_item: measuringItem, //측정항목
            standard: safetyInspection, //안전점검기준
            exp_date: expirationPeriod, //유효기간
            applicant: applicant, //신청자
            phone_number: phoneNumber //휴대폰 번호
        };
        console.log(formData);
        try {
            if (!accessToken) return;
            await api.postCertification(accessToken, formData);
            setLoadingState(true);
            window.location.reload();
        } catch (error: any) {
            setLoadingState(false);
            setAlarmText("게시글 등록 중 오류가 발생했습니다.");
        }
    }

    // 수정 확인 모달
    const [isModifyConfirmModal, setIsModifyConfirmModal] = useState(false);
    const openModifyConfirmModal = () => {
        if (validation()) return;
        setIsModifyConfirmModal(true);
    }
    const closeModifyConfirmModal = () => {
        setIsModifyConfirmModal(false);
    }

    // 수정 모달에서 확인 버튼 클릭시
    const handleModify: any = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const formData: StructureDto = {
            structure_num: facilityNumber,
            applicant: applicant,
            structure_name: facilityName,
            construction: mainStructure,
            measure_item: measuringItem,
            safety_grade: safetyLevel,
            address: location.concat('?' + detailLocation),
            exp_date: expirationPeriod,
            standard: safetyInspection,
            phone_number: phoneNumber
        };
        try {
            if (!accessToken) return;
            await api.putCertification(accessToken, formData);
            setLoadingState(true);
            window.location.reload();
        } catch (error: any) {
            setAlarmText("게시글 수정 중 오류가 발생했습니다.");
        }
    }

    return (
        <>
            <AlarmModal2>
                <h2>건축물 안전 인증서 {mode === 'add' ? "등록" : "수정"}</h2>
                <form onSubmit={mode === 'add' ? handleSubmit : handleModify}>
                    <ul className="input-area">
                        <li>
                            <ul>
                                <li>
                                    <h3>시설물 번호<span>*</span></h3>
                                    <div className="input-btn-box">
                                        <CS.TextInputType1
                                            placeholder='시설물 번호'
                                            type='text'
                                            value={facilityNumber}
                                            onChange={handleFacilityNumberChange}
                                            disabled={mode === '' ? true : false}
                                        />
                                        <CS.Btn4Type1
                                            type='button'
                                            onClick={handleDuplicateHits}
                                            disabled={mode === '' ? true : false}
                                        >
                                        중복 조회
                                        </CS.Btn4Type1>
                                    </div>
                                </li>
                                <li>
                                    <h3>신청자<span>*</span></h3>
                                    <CS.TextInputType1
                                        placeholder='신청자'
                                        type='text'
                                        value={applicant}
                                        onChange={handleApplicantChange}
                                    />
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <h3>휴대폰 번호<span>*</span></h3>
                                    <CS.TextInputType1
                                        placeholder='휴대폰 번호(-자 제외)'
                                        type='text'
                                        value={phoneNumber}
                                        onChange={handlePhoneNumberChange}
                                        maxLength={11}
                                    />
                                </li>
                                <li>
                                    <h3>시설물 명</h3>
                                    <CS.TextInputType1
                                        placeholder='시설물명'
                                        type='text'
                                        value={facilityName}
                                        onChange={handleFacilityNameChange}
                                    />
                                </li>
                            </ul>
                            <ul>
                            <li>
                                <h3>주구조</h3>
                                    <CS.TextInputType1
                                        placeholder='주구조'
                                        type='text'
                                        value={mainStructure}
                                        onChange={handleMainStructureChange}
                                    />
                                </li>
                                <li>
                                    <h3>측정 항목</h3>
                                    <CS.TextInputType1
                                        placeholder='측정 항목'
                                        type='text'
                                        value={measuringItem}
                                        onChange={handleMeasuringItemChange}
                                    />
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <h3>소재지<span>*</span></h3>
                                    <div className="input-btn-box">
                                        <CS.TextInputType1
                                            placeholder='주소'
                                            type='text'
                                            value={location}
                                            readOnly={true}
                                        />
                                        <CS.Btn4Type1
                                            type='button'
                                            value='주소 검색'
                                            onClick={() => {setIsPostModal(true);}}
                                        >주소 검색</CS.Btn4Type1>
                                    </div>
                                    <CS.TextInputType1
                                        placeholder='상세 주소'
                                        type='text'
                                        value={detailLocation}
                                        onChange={handleDetailLocationChange}
                                    />
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <h3>안전등급<span>*</span></h3>
                                    <CS.SelectType1>
                                        <select 
                                            value={safetyLevel}
                                            onChange={handleSafetyLevelChange}
                                            ref={safetyLevelRef}
                                            className={mode === '' ? 'selected' : ''}
                                        >
                                            <option value="" disabled={true}>안전등급</option>
                                            <option value="SCC-1">SCC-1</option>
                                            <option value="SCC-2">SCC-2</option>
                                        </select>
                                        <span className='img-box'>
                                            <img src="./img/arrow_bottom_898989.svg" alt="" />
                                        </span>
                                    </CS.SelectType1>
                                </li>
                                <li>
                                    <h3>유효기간<span>*</span></h3>
                                    <CS.TextInputType1
                                        placeholder='측정 항목'
                                        type='date'
                                        value={expirationPeriod}
                                        onChange={handleExpirationPeriodChange}
                                        min={today}
                                        className='selected'
                                    />
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <h3>안전점검기준</h3>
                                    <CS.TextInputType1
                                        placeholder='안전점검기준'
                                        type='text'
                                        value={safetyInspection}
                                        onChange={handleSafetyInspectionChange}
                                    />
                                </li>
                                <li></li>
                            </ul>
                        </li>
                    </ul>
                    <div className="btn-box">
                        <CS.Btn2Type2 type='button' onClick={onClose}>취소</CS.Btn2Type2>
                        {mode === 'add' && (
                            <CS.Btn2Type1 type='submit'>확인</CS.Btn2Type1>
                        )}
                        {mode === '' && (
                            <CS.Btn2Type1 type='button' onClick={openModifyConfirmModal}>수정</CS.Btn2Type1>
                        )}
                    </div>
                </form>
            </AlarmModal2>

            {isPostModal && (
                <CS.ModalBg>
                    <DaumPostcode
                        className='post-modal-box'
                        onComplete={onCompletePost}
                    />
                </CS.ModalBg>
            )}

            {isModifyConfirmModal && (
                <AlarmModal3
                    modalType='modify'
                    onClose={closeModifyConfirmModal}
                    onConfirm={handleModify}
                />
            )}
        </>
    );
}

export default CertificateModal;